export default __webpack_public_path__ + "static/media/termsOfUseEn.a07005e2.md";